import { useAuthFetch } from "matsuri-hooks"
import { useAccountInfoCtx } from "./useAccountInfo"
import { useAuth } from "./useAuth"
import { User } from "@/domain/user"
import { m2mUsers } from "@/endpoints/m2m-users"

export const useCurrentUser = (enabled = true) => {
    const { token } = useAuth()
    const { jwtPayload } = useAccountInfoCtx()
    const { data: user } = useAuthFetch<User>(
        token,
        enabled ? m2mUsers.v1.findUserById({ id: jwtPayload.userId }) : null,
        {
            authTokenHeader: "X-Access-Token"
        }
    )
    return user
}
